import {network, users as typesUsers} from "types";

export const getUsersResponseValidators = (
  response: network.TQueryDefWrapper<typesUsers.TUsersResponse>,
): typesUsers.TUsersResponse => {
  if (typeof response === 'object' && 'users' in response && 'currentPage' in response && 'count' in response && 'lastPage' in response) {
    return response;
  } else {
    return {
      currentPage: 1,
      count: 0,
      lastPage: 1,
      users: [],
    };
  }
}
